import React from 'react';

export default function ScanTicketWh({ width = '180', height = '92' }: { width?: string; height?: string }) {
  return (
    <svg width={width} height={height} viewBox="0 0 180 92" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M156 2H24C21.7909 2 20 3.79086 20 6V86C20 88.2091 21.7909 90 24 90H156C158.209 90 160 88.2091 160 86V6C160 3.79086 158.209 2 156 2Z"
        fill="white"
        stroke="#01172E"
        strokeWidth="4"
      />
      <path
        d="M158 83L158 86C158 87.1046 157.105 88 156 88L24 88C22.8954 88 22 87.1046 22 86L22 83L158 83Z"
        fill="#E5E5E5"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M158 48V52L22 52V48L158 48Z" fill="#EA1319" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50 16V44H58V16H64V44H70V16H74V44H82V16H88V44L94 43.999V16H98V43.999H106V16H110V43.999H118V16H124V43.999H130V16H134V43.999L180 44V48L134 47.999V76H130V47.999H124V76H118V47.999H110V76H106V47.999H98V76H94V47.999L88 48V76H82V48H74V76H70V48H64V76H58V48H50V76H46V48H0V44H46V16H50Z"
        fill="#01172E"
      />
    </svg>
  );
}
